import { useStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import {
  computed, ComputedRef, Ref, ref,
} from 'vue';

import zipRegExp from '@/rules/regexp/Zip';
import { getRequestHandler } from '@/services/requestHandler';
import { Onboarding } from '@/services/requests/onboarding/Onboarding.types';
import { OnboardingCommonRequests } from '@/services/requests/onboarding/OnboardingRequests';

export const useOnboardingCommonStore = defineStore('OnboardingCommon', () => {
  const countries = useStorage<Onboarding.Country[]>('countries', [], localStorage);

  const countriesMap = computed<Record<string, Onboarding.Country>>(() => {
    if (!countries.value || countries.value.length === 0) return {};

    return countries.value.reduce<Record<string, Onboarding.Country>>((acc, country) => {
      acc[country.alpha3] = country;
      return acc;
    }, {});
  });

  function getCountryZipRegexp(countryIso3: string, defaultRegexp: RegExp = zipRegExp.expression): string | RegExp {
    const stringRegexp = countriesMap.value[countryIso3]?.postalCodeRegex;
    return stringRegexp
      ? new RegExp(stringRegexp)
      : defaultRegexp;
  }

  function useCountryZipRegexp(): [Ref<string>, ComputedRef<string | RegExp>] {
    const countryIso3Ref = ref<string>('');
    const computedCountryZipRegexp = computed(() => getCountryZipRegexp(countryIso3Ref.value));

    return [countryIso3Ref, computedCountryZipRegexp];
  }

  return {
    fetchCountries: getRequestHandler(OnboardingCommonRequests.getCountries, {
      onSuccess: (response) => {
        countries.value = response;
      },
    }),

    useCountryZipRegexp,

    $reset() {
      countries.value = [];
    },
  };
});
